import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DescriptionIcon from "@mui/icons-material/Description";
import RestoreIcon from "@mui/icons-material/Restore";
import { useTheme } from "@mui/material/styles";

export const DocumentCard = React.memo(({ documents, onOpenUpdateModal, onOpenDesactiveModal }) => {
  const theme = useTheme();

  const isInactive = documents?.FLG_ACTIVO === 0 || documents?.FLG_ACTIVO === "0";

  const handleDeleteClick = () => {
    onOpenDesactiveModal(documents);
  };

  return (
    <>
      <Card
        sx={{
          borderRadius: "12px",
          backgroundColor: theme.palette.background.paper,
          transition: "all 0.3s ease",
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.shadows[1],
          height: "100%",
          display: "flex",
          flexDirection: "column",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: theme.shadows[6],
            borderColor: theme.palette.primary.main,
          },
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            p: { xs: 2, sm: 3 },
          }}
        >
          <Box display="flex" alignItems="center" mb={2} gap={2}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                borderRadius: "12px",
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.contrastText,
                flexShrink: 0,
              }}
            >
              <DescriptionIcon />
            </Box>
            <Box>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  lineHeight: 1.2,
                  mb: 0.5,
                }}
              >
                {documents.NOMBRE_DOCUMENTO || "Documento sin nombre"}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: { xs: "0.8rem", sm: "0.875rem" },
                }}
              >
                ID: {documents.ID_DOCUMENTO}
              </Typography>
            </Box>
          </Box>

          <Box mt="auto" display="flex" justifyContent="flex-end" gap={1}>
            {isInactive ? (
              <Tooltip title="Restaurar documento" arrow>
                <IconButton
                  onClick={() => onOpenDesactiveModal(documents)}
                  size="small"
                  sx={{
                    color: theme.palette.success.main,
                    border: `1px solid ${theme.palette.divider}`,
                    "&:hover": {
                      backgroundColor: theme.palette.success.main,
                      color: theme.palette.success.contrastText,
                      borderColor: theme.palette.success.main,
                    },
                  }}
                >
                  <RestoreIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            ) : (
              <>
                <Tooltip title="Editar documento" arrow>
                  <IconButton
                    onClick={() => onOpenUpdateModal(documents)}
                    size="small"
                    sx={{
                      color: theme.palette.primary.main,
                      border: `1px solid ${theme.palette.divider}`,
                      "&:hover": {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderColor: theme.palette.primary.main,
                      },
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Eliminar documento" arrow>
                  <IconButton
                    onClick={handleDeleteClick}
                    size="small"
                    sx={{
                      color: theme.palette.error.main,
                      border: `1px solid ${theme.palette.divider}`,
                      "&:hover": {
                        backgroundColor: theme.palette.error.main,
                        color: theme.palette.error.contrastText,
                        borderColor: theme.palette.error.main,
                      },
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </Box>
        </CardContent>
      </Card>
    </>
  );
});
